import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./studentattendancestatus.component.html",
})
export class StudentAttendanceStatusComponent {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		startDate: new Date(),
		endDate: new Date(),
		NumOfDaysID: 1,
		AttendanceStatusID: 0,
		SortBy: "Status Count",
		ShowDetail: "Yes",
		ImageLogo: "",
	};

	schoolList: any = [];
	lstNumberOfDays: any = [];
	ImageLogoList: any = [];

	attendanceStatusList: any = [];
	user: any;
	errorMessage: any = "";
	isProcessing: any = false;
	lstShowDetail = [
		{
			ShowDetailDesc: "Yes",
		},
		{
			ShowDetailDesc: "No",
		},
	];
	lstSortBy = [
		{
			SortByDesc: "Name",
		},
		{
			SortByDesc: "Academy",
		},
		{
			SortByDesc: "Homeroom",
		},
		{
			SortByDesc: "Grade",
		},
		{
			SortByDesc: "Status Count",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 26;

	subscription: any;
	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	ngOnInit() {
		// this.loadSchoolist();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});

		this.loadNumDays();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadNumDays() {
		var i;
		for (i = 1; i <= 100; i++) {
			this.lstNumberOfDays.push({
				NumOfDays: i,
				NumOfDaysDesc: i.toString(),
			});
		}
		this.report.NumOfDaysID = this.lstNumberOfDays[0].NumOfDays;
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(26);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.AttendanceStatusList();
		this.loadLogolist();
	}

	private AttendanceStatusList() {
		this.report.AttendanceStatusID = 0;
		var result = this.reportService.AttendanceStatusGetList();
		result.subscribe(
			(response) => {
				this.attendanceStatusList = response;

				if (this.attendanceStatusList.length > 1) {
					// this.attendanceStatusList.unshift({
					//     AttendanceStatusID: 0,
					//     AttendanceStatusDesc: "All Attendance Status"
					// })
				} else {
					this.report.AttendanceStatusID = this.attendanceStatusList[0].AttendanceStatusID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 26;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += "<ROOT><School SchoolID='" + this.report.SchoolID + "'/></ROOT>";
		strParam += "|SchoolXML";

		var startDate = moment(this.report.startDate).format("MM/DD/YYYY");
		var endDate = moment(this.report.endDate).format("MM/DD/YYYY");

		strParam += "," + this.report.AttendanceStatusID + "|AttendancestatusID";
		strParam += "," + this.report.NumOfDaysID + "|NumberOf";
		strParam += "," + startDate + "|StartDate";
		strParam += "," + endDate + "|EndDate";
		strParam += "," + this.report.SortBy + "|ORDERBY";
		strParam += "," + this.report.ShowDetail + "|ShowDetail";

		// strParam += "," + vm.searchOptions.sortBy + "|ORDERBY"
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
